(function(){
    //Bunch of code...
  
    $('#proteinresult').hide();
    var unittext = 'Gramm Protein/Tag';
    $('#proteincalc').click(function() {
        var proteinmin = $('#proteingoal option:selected').data('min');
        var proteinmax = $('#proteingoal option:selected').data('max');
        var proteinweight = $('#proteinweight').val();

        if(proteinmin && proteinmax && proteinweight){
            var minvalue = proteinmin*proteinweight;
            var maxvalue = proteinmax*proteinweight;
            $('.protein-result').html(minvalue.toFixed(0) + ' - ' + maxvalue.toFixed(0) + ' ' + unittext);
            $('#proteincalc').fadeOut( "slow", function() {
                $('#proteinresult').fadeIn("slow");
            });
        }
    });

    $('#proteinrecalc').click(function() {
        $('#proteingoal').prop('selectedIndex',0);
        $('#proteinweight').prop('selectedIndex',0);

        $('#proteinresult').fadeOut("slow", function() {
            $('#proteincalc').fadeIn("slow");
        });
    });

    
})($);